import { useEffect } from "react"
import GesttorPage from "../../components/SistemaGesttor"

function Gesttor () {

    useEffect(() => {
        document.title = "Sistema Gesttor | Saiba Mais"
    }, [])

    return (
        <GesttorPage />
    )
}

export default Gesttor
